export default __webpack_public_path__ + "static/media/img1.83331a1e.webp";